import { h } from 'preact';
import Page from 'components/pages/page.js';
// import { Link } from 'components/core/link/link.js';
import Iframe from 'components/core/iframe/iframe.js';
import pure from 'utils/pure';
import { condClass } from 'utils/utils';
// import Store from 'store/store';
import s from 'components/pages/iframed/iframed.sss';
const isServer = typeof window === 'undefined';

/**
 * Full Screen iframe
 * @prop {Object} pageData - data for that page.
 * @prop {Boolean} sideNavActive - is the sidenav active on the page
 */
export default @pure class Iframed extends Page {

	constructor(props) {
		super(props);
		this.loaded = this.loaded.bind(this);
	}

	/**
	 * LIFECYCLE
	 */

	loaded() { }

	getExtraContent() { }

	render({ transitionClass, sideNavActive, pageData, client, id }) {
		let query = '';

		if (!isServer && !pageData.disableQuery) {
			query = location.search;
		}

		let iframeLink = pageData.iframeLink;
		if (pageData.iframeLinkMobile && client.deviceSize === 'mobile') {
			iframeLink = pageData.iframeLinkMobile;
		}

		if (iframeLink.match(/\?/)) {
			query = query.replace(/\?/, '&');
		}

		const scrollable = pageData.scrollable;

		const iframeAriaLabel = pageData.iframeAriaLabel || '';

		return (
			<div class={s.wrapper + condClass(transitionClass) + condClass(s['page-' + id])}>
				<Iframe
					id={pageData.iframeId}
					src={iframeLink+query}
					ariaLabel={iframeAriaLabel}
					percentageDimensions={sideNavActive}
					onLoad={this.loaded}
					scrollable={scrollable}
					isIOS={client.isIOS}
				/>
				{this.getExtraContent()}
			</div>
		);
	}
}
